export function traduceWeather(weather) {
  switch (weather) {
    case "Thunderstorm":
      return "Trovoadas";
    case "Drizzle":
      return "Chuvisco";
    case "Rain":
      return "Chuva";
    case "Snow":
      return "Neve";
    case "Atmosphere":
      return "Atmosfera";
    case "Clear":
      return "Céu Limpo";
    case "Clouds":
      return "Nublado";
    default:
      return "Céu Limpo";
  }
}

//clean code here 👇

const traduceW = (w) => {
  const opts = {
    Thunderstorm: "Trovoadas",
    Drizzle: "Chuvisco",
    Rain: "Chuva",
    Snow: "Neve",
    Atmosphere: "Atmosfera",
    Clear: "Céu Limpo",
    Clouds: "Nublado",
  };

  return opts[w] || "Céu Limpo";
}
